import { Component, signal, TemplateRef } from '@angular/core'
import { ModalHeaderComponent } from '../modal-header/modal-header.component'
import { ModalBodyComponent } from '../modal-body/modal-body.component'
import { ModalFooterComponent } from '../modal-footer/modal-footer.component'
import { NgTemplateOutlet } from '@angular/common'

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    NgTemplateOutlet,
  ],
  selector: 'app-confirmation-modal',
  styles: '',
  template: `
    <div app-modal-header>{{headerText()}}</div>

    <div app-modal-body>
      <ng-container 
        [ngTemplateOutlet]="bodyTemplate()" 
        [ngTemplateOutletContext]="{ctx: bodyContext()}"></ng-container>
    </div>

    <div app-modal-footer>
      <button class="action-btn primary" [disabled]="!canConfirm()()" (click)="onConfirm()()">
        {{confirmButtonText()}}
      </button>
      <button class="action-btn" (click)="onCancel()()">
        {{cancelButtonText()}}
      </button>
    </div>
  `,
})
export class ConfirmationModalComponent<T = unknown> {
  public headerText = signal('Confirm')
  public confirmButtonText = signal('Confirm')
  public cancelButtonText = signal('Cancel')
  public canConfirm = signal((): boolean => true)
  public onConfirm = signal((): void => void 0)
  public onCancel = signal((): void => void 0)
  public bodyContext = signal(null as T | null)
  public bodyTemplate = signal(null as TemplateRef<{ ctx: T }> | null)

  init(overrides: Partial<{
    headerText: string
    confirmButtonText: string
    cancelButtonText: string
    canConfirm: () => boolean
    onConfirm: () => void
    onCancel: () => void
    bodyContext: T
    bodyTemplate: TemplateRef<{ ctx: T }>
  }> = {}) {
    this.headerText.update(v => overrides.headerText ?? v)
    this.confirmButtonText.update(v => overrides.confirmButtonText ?? v)
    this.cancelButtonText.update(v => overrides.cancelButtonText ?? v)
    this.canConfirm.update(v => overrides.canConfirm ?? v)
    this.onConfirm.update(v => overrides.onConfirm ?? v)
    this.onCancel.update(v => overrides.onCancel ?? v)
    this.bodyContext.update(v => overrides.bodyContext ?? v)
    this.bodyTemplate.update(v => overrides.bodyTemplate ?? v)
  }
}
